// src/redux/reducers/marketReducer.js

// ---- state ----
const initialState = {
  // ticks: { BTC: { USDT: 65000, USD: 64980 }, ETH: { USDT: 3200 }, ... }
  ticks: Object.create(null),
  ticksReady: false,
};

// ---- helpers ----
function splitSymbol(raw) {
  const s = String(raw || '').toUpperCase();
  const quotes = ['USDT','USDC','BUSD','TUSD','USD','DAI','BTC','ETH'].sort((a,b)=>b.length-a.length);
  for (const q of quotes) {
    if (s.endsWith(q)) {
      const base = s.slice(0, -q.length);
      if (base) return { base, quote: q };
    }
  }
  return { base: s, quote: '' };
}

// ---- action types ----
const TICKS_BATCH_RECEIVED = 'market/TICKS_BATCH_RECEIVED';
const RESET_MARKET         = 'market/RESET_MARKET';

// ---- reducer ----
export default function marketReducer(state = initialState, action) {
  switch (action.type) {
    case TICKS_BATCH_RECEIVED: {
      const next = { ...state.ticks };
      for (const t of action.payload || []) {
        const { base, quote } = splitSymbol(t?.s);
        const last = Number(t?.c);
        if (!base || !quote || !Number.isFinite(last)) continue;
        const qmap = next[base] ? { ...next[base] } : {};
        qmap[quote] = last;
        next[base] = qmap;
      }
      return { ...state, ticks: next, ticksReady: true };
    }
    case RESET_MARKET:
      return { ticks: Object.create(null), ticksReady: false };
    default:
      return state;
  }
}

// ---- action creators ----
export const ticksBatchReceived = (arr) => ({ type: TICKS_BATCH_RECEIVED, payload: arr });
export const resetMarket        = () => ({ type: RESET_MARKET });

// ---- selectors ----
export const selectTicks       = (s) => s.market?.ticks || {};
export const selectTicksReady  = (s) => Boolean(s.market?.ticksReady);
